import {
    FETCH_DATA_REQUEST, FETCH_INTAKEBOOK_DATE_CONFIG, SET_INTAKEBOOK_SELECTED_DATE, INTAKEBOOK_SELECTED_DATE_CHANGED,
    RESET_MODEL_AND_ERROR_FLAGS, DISPLAY_ERROR_MESSAGE, SHOW_HIDE_LOADER, SET_SHOW_INSTRUCTION_MODEL
    , INTAKEBOOK_DATE_CHANGE_FLAG, SET_CHANGE_REQUEST_NUMBER, SET_UNBLOCK_FROM_DATE_AND_CONTRACT_CODE
} from './actionTypes';

export const calendarIntakeBookReducer = (state, action) => {
    switch (action.type) {
        case FETCH_DATA_REQUEST:
            return {
                ...state,
                isLoading: action.payload.isLoading,
                isError: action.payload.isError,
                showModel: false,
                modelHeaderTitle: "",
                errorMessage: action.payload.errorMessage,
                showInstructions: false,
                isDateChangeFlag: false,
                changeReqNumber: null,
                requestStatus: 0
            }
        case FETCH_INTAKEBOOK_DATE_CONFIG:
            return {
                ...state,
                intakeBookStartDate: action.payload.intakeBookStartDate,
                minDate: action.payload.minDate,
                maxDate: action.payload.maxDate,
                sessionTimeoutLimit: action.payload.sessionTimeoutLimit,
                idleTimeoutLimit: action.payload.idleTimeoutLimit
            };
        case SET_INTAKEBOOK_SELECTED_DATE:
            return {
                ...state,
                intakeBookStartDate: action.payload.intakeBookStartDate,
                isDateChangeFlag: false
            }
        case INTAKEBOOK_SELECTED_DATE_CHANGED:
            return {
                ...state,
                isDateChanged: action.payload.isDateChanged,
                isDateChangeFlag: false
            }
        case INTAKEBOOK_DATE_CHANGE_FLAG:
            return {
                ...state,
                isDateChangeFlag: true,
                newSelectedDate: action.payload.newSelectedDate,
                oldSelectedDate: action.payload.oldSelectedDate
            }
        case SET_SHOW_INSTRUCTION_MODEL: {
            return {
                ...state,
                showModel: action.payload.showModel,
                showInstructions: action.payload.showInstructions,
                modelHeaderTitle: action.payload.modelHeaderTitle
            }
        }
        case RESET_MODEL_AND_ERROR_FLAGS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                errorMessage: "",
                showModel: false,
                modelHeaderTitle: "",
                showInstructions: false,
                changeReqNumber: null,
                requestStatus: 0
            }
        case SHOW_HIDE_LOADER:
            return {
                ...state,
                isLoading: action.payload.isLoading
            }
        case DISPLAY_ERROR_MESSAGE:
            return {
                ...state,
                isLoading: action.payload.isLoading,
                isError: action.payload.isError,
                errorMessage: action.payload.errorMessage,
                showModel: action.payload.showModel,
                modelHeaderTitle: action.payload.modelHeaderTitle,
                showInstructions: false,
                isFileUploadedSuccessfully: action.payload.isFileUploadedSuccessfully,
                isSuccessfullySaved: action.payload.isSuccessfullySaved,
                requestStatus: action.payload.requestStatus
            }
        case SET_CHANGE_REQUEST_NUMBER:
            return {
                ...state,
                changeReqNumber: action.payload.changeReqNumber
            }
        case SET_UNBLOCK_FROM_DATE_AND_CONTRACT_CODE:
            return {
                ...state,
                unblockFromDate: action.payload.unblockFromDate,
                selectedContractCodeValue: action.payload.selectedContractCodeValue
            }
        default:
            return state;
    }
}